/** Incrémenter à chaque déploiement front mail (aligné meta index.html + service-worker.js). */
export const MAIL_BUILD_VERSION = "20261030mail520";

export const MAIL_BUILD_VERSION_LS_KEY = "mail_build_version";

/** Build pour lequel on a déjà proposé / appliqué la bannière MAJ (évite la boucle). */
export const MAIL_SW_PROMPTED_BUILD_LS_KEY = "mail_sw_prompted_build";
